import storeLogoMap from "../dataLists/storeLogoMap.json";
import storePhotoMap from "../dataLists/storePhotoMap.json";

export const FALLBACK_STORE_IMAGE = "/icon/favicon-circle.png";

const CDN_PHOTO_PREFIX =
  "https://creative.cdn.apm.any-digital.com/h5/findpoketcgstore/store-photos/";

const normalizeUrl = (url: string): string => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `https://${url}`;
};

export const getStoreLogoUrl = (storeWebsite: string): string => {
  const normalizedUrl = normalizeUrl(storeWebsite);
  if (!normalizedUrl) return FALLBACK_STORE_IMAGE;

  const exact = storeLogoMap[normalizedUrl as keyof typeof storeLogoMap];
  if (exact) return exact;

  const alternateUrl = normalizedUrl.endsWith("/")
    ? normalizedUrl.slice(0, -1)
    : `${normalizedUrl}/`;
  const alternate = storeLogoMap[alternateUrl as keyof typeof storeLogoMap];
  if (alternate) return alternate;

  return FALLBACK_STORE_IMAGE;
};

/**
 * Returns the static CDN store photo URL when mapped.
 * Legacy Places photo_reference strings are ignored (logo fallback).
 */
export const getStorePhotoUrl = (
  placeId?: string,
  _maxWidth = 400,
): string | null => {
  if (!placeId) return null;
  const mapped = storePhotoMap[placeId as keyof typeof storePhotoMap];
  if (typeof mapped !== "string" || !mapped) return null;
  if (!mapped.startsWith(CDN_PHOTO_PREFIX)) return null;
  return mapped;
};

/** Prefer CDN store photo, then website logo, then local fallback. */
export const getStoreImageUrl = (
  placeId?: string,
  storeWebsite = "",
  maxWidth = 400,
): string => {
  return (
    getStorePhotoUrl(placeId, maxWidth) ||
    getStoreLogoUrl(storeWebsite) ||
    FALLBACK_STORE_IMAGE
  );
};
